import { render, staticRenderFns } from "./ResCommission.vue?vue&type=template&id=75586504&scoped=true"
import script from "./ResCommission.vue?vue&type=script&lang=js"
export * from "./ResCommission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75586504",
  null
  
)

export default component.exports